import {Outlet} from 'react-router-dom';

import MenuLayout, {
  type MenuLayoutProps,
} from '@/components/layouts/MenuLayout';
import SimpleLayout from '@/components/layouts/SimpleLayout';
import {useAuthorize} from '@/hooks/useAuth';
import WhatsNewDialog from '@/shared/release-notes/components/WhatsNewDialog';

import RootCommands from '../components/RootCommands';
import RootDialogs from '../components/RootDialogs';

export type RootPageProps = Omit<MenuLayoutProps, 'children'>;

const RootPage = (props: RootPageProps) => {
  const menuView = useAuthorize('VIEW_MENU');

  return (
    <>
      {menuView ? (
        <MenuLayout {...props}>
          <Outlet />
        </MenuLayout>
      ) : (
        <SimpleLayout className={props.className}>
          <Outlet />
        </SimpleLayout>
      )}
      <RootCommands />
      <RootDialogs />
      <WhatsNewDialog />
    </>
  );
};

export default RootPage;
